import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { gridHangingProtocolNameState } from '~/state/atoms/viewportGridAtoms';
import { HangingProtocol, hangingProtocolByName } from '~/viewportGrid';

export interface HangingProtocolBinding {
    /** The shape asked of every row, or `undefined` while none is asked. */
    readonly hangingProtocol: HangingProtocol | undefined;
    /** Records the shape the rows hang. Stable across renders. */
    readonly onHangingChanged: (protocol: HangingProtocol | undefined) => void;
}

/**
 * Binds a grid host to the shared hanging-protocol atom. The layout menu
 * writes a name to ask for a shape; the host writes back the shape its rows
 * are in, and `null` in the atom says a row hangs its own way. The pair maps
 * straight onto the host's `hangingProtocol` and `onHangingChanged` props.
 */
export function useHangingProtocolBinding(): HangingProtocolBinding {
    const [name, setName] = useRecoilState(gridHangingProtocolNameState);
    const hangingProtocol =
        name === null ? undefined : hangingProtocolByName(name);
    const onHangingChanged = useCallback(
        (protocol: HangingProtocol | undefined) =>
            setName(protocol?.name ?? null),
        [setName]
    );
    return { hangingProtocol, onHangingChanged };
}
